import React from 'react';

import { Tooltip, Typography } from '@mui/material';

interface Props {
  children: React.ReactNode;
  title: string;
}

export default function TruncatedCellText({ children, title }: Props) {
  return (
    <Tooltip title={title}>
      <Typography
        component="span"
        variant="body2"
        sx={{ display: 'block', minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
      >
        {children}
      </Typography>
    </Tooltip>
  );
}
